import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('quick-help', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('quick-help');

      return new ViewModel(params, element);
    },
  },
  template: html,
});